module.exports = __webpack_public_path__ + "img/IMG_3338.b5330182.jpeg";